import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'

import { ConfirmDialog } from '@root/shared/ui-kit'

import { confirmDialogControllerAtom } from './reatom-confirm-dialog-controller'

export const ConfirmDialogController = () => {
  const [open, setOpen] = useAtom(confirmDialogControllerAtom)
  return (
    <AnimatePresence>
      {open ? (
        <ConfirmDialog
          {...open}
          open
          onOpenChange={(x) => {
            open.onOpenChange?.(x)
            setOpen(undefined)
          }}
        />
      ) : undefined}
    </AnimatePresence>
  )
}
